(function ($) {
    //Setup date selectors
    if ($.datepicker) {
        $('input.dateselector').datepicker({ onClose: function () { $(this).blur(); } });
    }

    //Setup date and time selectors
    if ($.fn.datetimepicker) {
        $('input.datetimeselector').datetimepicker({ onClose: function () { $(this).blur(); } });
    }
})(jQuery);